export default "__VITE_ASSET__hOte54Ue__"